import { PersonalizationResourceType } from "@bloomberg/intercom";

import intercom from "~config/intercom";
import { Story } from "~types/types";

import { PersonalizationStory } from "../PersonalizationStory";

export const getVideoPersonalizedStories = async (story: Story) => {
    const relatedStories = await intercom.getRelated({
        resourceTypes: [PersonalizationResourceType.Video],
        currentResource: `Story|${story.id}`,
        excludedSites: "bview",
        limit: 1,
        thumbnailRequired: true,
        maxAge: 86400000,
    });

    return relatedStories.filter(
        (relatedStory: PersonalizationStory) =>
            relatedStory.assetType === "Video"
    );
};
